import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 3V11H21V13H13V21H11V13L3 13L3 11H11V3H13Z", stroke: "none", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgAdd);
export default ForwardRef;
